import React, { type FC } from 'react';
import { cn } from '@/lib/utils';

interface CellButtonProps {
  /** If true, only show this button on hover */
  showOnHover?: boolean;
}

const CellButton: FC<React.PropsWithChildren<CellButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>> = ({
  showOnHover,
  onClick,
  className,
  ...rest
}) => {
  return (
    <button
      type="button"
      data-testid="qa-cell-button"
      className={cn([
        'w-[85px] h-[20px] rounded-[10px] border border-solid text-[12px] text-center cursor-pointer leading-[1.6] [&_i]:mr-[5px]',
        showOnHover ? 'hidden [tr:hover_&]:block' : '',
        className,
      ])}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      {...rest}
    />
  );
};

export default CellButton;
